/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./config-card.vue?vue&type=template&id=4b5edb6c&"
import script from "./config-card.vue?vue&type=script&lang=js&"
export * from "./config-card.vue?vue&type=script&lang=js&"
import style0 from "./config-card.vue?vue&type=style&index=0&id=4b5edb6c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports